<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">Edit Cost</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
  </div>
  <mat-spinner *ngIf="historyLoading"></mat-spinner>
  <div class="ttmodal__body" *ngIf="!historyLoading">
    <table class="table table--striped table--full-width">
      <thead>
        <tr>
          <!-- <th style="width: 20px">More</th> -->
          <th>Component Name</th>
          <th>Side</th>
          <th>Position</th>
          <th>Cost</th>
          <th>New Cost</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let point of actionHistoryComponentData; let i = index" class="table-row-style"
          click-stop-propagation>
          <td>{{point.CompartName}}</td>
          <td>{{point.Side == 1 ? "Left" : point.Side == 2 ? "Right" : ""}}</td>
          <td> {{getPositionStringDoubleComponents(point.Pos,point.CompartTypeId)}}</td>
          <td>
            <span *ngIf="!point.Replaced">{{point.Cost}}</span>
            <span *ngIf="point.Replaced">0</span>
          </td>
          <td> <mat-form-field #newCostInput class="example-full-width" *ngIf="!point.Replaced">
              <input matInput placeholder="New Cost" id="newCost{{point.EqUnitId}}" value="newCost{{point.EqUnitId}}"
                [(ngModel)]="point.NewCost" (focusout)="UpdateComponentCost(point)">

            </mat-form-field>
            <span *ngIf="point.Replaced">Replaced</span>
          </td>

        </tr>

      </tbody>
    </table>
  </div>